import { style } from '@vanilla-extract/css';

import rootStyles from '../rootElement/Root.css';

const { rootElement } = rootStyles;

export const heading = style({
  position: 'var(--position, relative)',
  top: 'var(--position-top)',
  right: 'var(--position-right)',
  bottom: 'var(--position-bottom)',
  transform: 'var(--position-transform)',
  left: 'var(--position-left)',
  zIndex: 'var(--z-index)',
  color: 'var(--base-color, inherit)',
  margin: 'var(--margin)',
  padding: 'var(--padding)',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  lineHeight: 'var(--line-height)',
  textAlign: 'var(--text-align)',
  backgroundColor: 'var(--background-color)',
  borderRadius: 'var(--border-radius)',
  borderWidth: 'var(--border-width)',
  borderColor: 'var(--border-color)',
  borderStyle: 'var(--border-style)',
  letterSpacing: 'var(--letter-spacing)',

  '@media': {
    'only screen and (--mobile)': {
      lineHeight: 'var(--mobile-line-height)',
      textAlign: 'var(--mobile-text-align)',
      padding: 'var(--mobile-padding, var(--padding))',
    },
  },

  selectors: {
    [`.ProseMirror > .react-renderer > &, ${rootElement} > &`]: {
      padding: 'var(--padding-root)',
    },
  },
});

export const h1Element = style({
  selectors: {
    'h1&': {
      fontWeight: '800',
      letterSpacing: 'var(--letter-spacing)',
    },
  },
});

export const h2Element = style([
  {
    selectors: {
      'h2&': {
        fontWeight: '800',
        letterSpacing: 'var(--letter-spacing)',
      },
    },
  },
]);

export const h3Element = style([
  {
    selectors: {
      'h3&': {
        fontWeight: '700',
        letterSpacing: 'var(--letter-spacing)',
      },
    },
  },
]);

export const h4Element = style([
  {
    selectors: {
      'h4&': {
        fontWeight: '700',
        letterSpacing: 'var(--letter-spacing)',
      },
    },
  },
]);

export const h5Element = style([
  {
    selectors: {
      'h5&': {
        fontWeight: '700',
        letterSpacing: 'var(--letter-spacing)',
      },
    },
  },
]);

export const h6Element = style([
  {
    selectors: {
      'h6&': {
        fontWeight: '700',
        letterSpacing: 'var(--letter-spacing)',
      },
    },
  },
]);
